import React from 'react';
import { IoHeart, IoLibrary } from 'react-icons/io5';
import { Link } from 'react-router-dom';

const ArchiveIntroModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 p-4"
            onClick={onClose}
        >
            <div 
                className="bg-background dark:bg-dark-background text-foreground dark:text-dark-foreground rounded-lg p-6 w-full max-w-md mx-4 shadow-xl"
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-2xl font-bold flex items-center">
                        <IoLibrary className="mr-2" />
                        ARCHIVE
                    </h2>
                    <button onClick={onClose} className="text-3xl font-light">&times;</button>
                </div>

                <p className="mb-6 text-center">
                    Enjoying Wordamid? Consider supporting the game to help keep the servers running!
                </p>

                <div className="flex flex-col space-y-4">
                    <a 
                        href="https://ko-fi.com/eliass_al" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="flex items-center justify-center space-x-2 bg-[#FF5E5B] text-white font-bold py-3 px-4 rounded-lg hover:opacity-90 transition-opacity"
                    >
                        <IoHeart className="text-xl" />
                        <span>Support on Ko-fi</span>
                    </a>

                    <div className="relative flex py-2 items-center">
                        <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>
                        <span className="flex-shrink-0 mx-4 text-gray-500 text-sm">THEN</span>
                        <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>
                    </div>

                    <Link 
                        to="/archive"
                        className="flex items-center justify-center space-x-2 bg-accent dark:bg-dark-accent text-background dark:text-dark-background font-bold py-3 px-4 rounded-lg hover:opacity-90 transition-opacity"
                    >
                        <span>Access Archive</span>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ArchiveIntroModal;


























